
<template>
    <div class="form-block">
        <div>
            <h2 class="form-block__title mb-3">{{title_form}}</h2>
            <div v-show="step === 1" class="form-block_body">
                <div class="black_block d-flex flex-column">
                    <div class="d-flex position-relative">
                        <div class="black_block__title">First name</div>
                        <input v-model="model_person.first_name" type="text" class="form-control">
                        <div @click="model_person.first_name = ''" class="btn-close btn-close-input"></div>
                    </div>
                    <hr>
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Last name</div>
                        <input v-model="model_person.last_name" type="text" class="form-control">
                        <div @click="model_person.last_name = ''" class="btn-close btn-close-input"></div>
                    </div>
                    <hr>
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Email</div>
                        <input v-model="model_person.email" type="email" class="form-control">
                        <div @click="model_person.email = ''" class="btn-close btn-close-input"></div>
                    </div>
                    <hr>
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Website</div>
                        <input v-model="model_person.link" type="text" class="form-control">
                        <div @click="model_person.link = ''" class="btn-close btn-close-input"></div>
                    </div>
                    <hr>
                    <div class="d-flex position-relative">
                        <div class="black_block__title">Info</div>
                        <input v-model="model_person.info" type="text" class="form-control">
                        <div @click="model_person.info = ''" class="btn-close btn-close-input"></div>
                    </div>
                </div>

            </div>
            <div v-show="step === 2" class="form-block_body">
                <div class="text-center mb-4">
                    <a href="#" >Read how to take a photo</a>
                </div>
                <div class="black_block dragdrop text-center">
                    <input @change="uploadImage" type="file" multiple id="uploadfile" class="d-none">
                    <label class="btn btn-upload" for="uploadfile">BROWSE FILES</label>
                </div>
                <div class="upload_group h240">
                    <div v-for="face in model_person.faces" class="black_block mt-3">
                        <div v-if="face.id" class="upload_item position-relative">
                            <div class="upload_item__left">
                                <div class="upload_item__left_top">
                                    <span>{{ face.image.path }}</span>
                                </div>
                            </div>
                            <div class="upload_item__right position-relative">
                                <div @click="removeImagePerson(face, key)" class="btn-close btn-close-rel"></div>
                            </div>
                        </div>
                        <div v-else class="upload_item position-relative">
                            <div class="upload_item__left">
                                <div class="upload_item__left_top">
                                    <span>{{ face.name }}</span>
                                    <span>{{ face.progress }}%</span>
                                </div>
                                <div class="progress">
                                    <div class="progress-bar" role="progressbar" :style="`width: ${face.progress}%`" :aria-valuenow="face.progress" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="upload_item__right position-relative">
                                <div class="btn-close btn-close-rel"></div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <div class="form-block__footer d-flex justify-content-between">
            <div class="form-block__footer_left d-flex justify-content-start align-items-end">
                <button v-show="step === 2" @click="setStep(1)" class="btn btn-link margin-r4">Step back</button>
            </div>
            <div class="form-block__footer_right d-flex justify-content-end align-items-end">
                <button @click="closePopup" class="btn btn-link">Cancel</button>
                
                <button 
                    v-show="step === 1 && this.crud=='create'"  @click="setStep(2)" 
                    class="btn btn-primary"
                >
                    Next step
                </button>

                <button 
                    v-show="step === 1 && this.crud=='update'"  
                    @click="updatePerson" 
                    class="btn btn-primary"
                >
                    Done
                </button>
                
                
                <button v-show="step === 2"  @click="donePerson" class="btn btn-primary">Done</button>
            </div>

        </div>
    </div>
</template>

<script>
import {bus} from '../../bus';
import axios from "axios";
export default {
    props: [
        'prop_titleform', 
        'category_id', 
        'person', 
        'crud'
    ],
    data(){
        return{
            title_form: '',
            model_person: {
                faces: [],
                first_name: '',
                last_name: '',
                email: '',
                link: '',
                info: '',
                category_id: this.category_id,
                id: '',
                uuid: ''
            },
            videos: [],
            faces: [],
            step: 1,
            progress: 0,
            person_id: '',
            files: [],
            images: '',
            sendPersonSDKnum: 0,
            sendPersonSDKlimit: 10,
            badImages: [],
            badImagesB64: [],
            spoofWarnings: [],
            image_turn_id: ''
        }
    },
    methods: {
        closePopup(){
            bus.$emit('openpopup' , {
                open: false
            });
        },
        setStep(id){
            this.step = id;
            if(id === 2){
                if(this.crud === 'create'){
                    // this.addPerson();
                }
                if(this.crud === 'update'){
                    
                    // this.addPerson();

                    

                    // this.updatePerson(this.model_person.id, this.category_id);
                }
            }
        },
        sendCategory(){
            // bus.$emit('addcategory', this.model_category);
            bus.$emit('openpopup', {
                open: false
            });
        },
        isSpoofSuspicion(flag){
            if (flag === true || flag === 1 || flag === '1') return true;
            if (Array.isArray(flag)) {
                return flag.some(function (x) {
                    return x === true || x === 1 || x === '1';
                });
            }
            return false;
        },
        addPerson(){
            
            let formData = new FormData();
            formData.append(`first_name`, this.model_person.first_name);
            formData.append(`last_name`, this.model_person.last_name);
            formData.append(`email`, this.model_person.email);
            formData.append(`info`, this.model_person.info);
            formData.append(`link`, this.model_person.link);
            formData.append(`category_id`, this.model_person.category_id);
            formData.append(`uuid`, this.model_person.uuid);
          
            let totalfiles = this.images.length;
            for (let index = 0; index < totalfiles; index++) {
                formData.append("faces[]", this.images[index]);
            }
            
            axios.post( '/persons',            
                formData,
                {
                    headers: {                        
                        "Content-Type": "multipart/form-data",                        
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'updateDuringAddPerson': 'y'
                    }
                }         
            ).then((response)=>{
                console.log('/*persons', response);
                //if create person and return person id
                if(response.data){
                    this.model_person.id = response.data;                    
                    bus.$emit('getListPerson', true);
                    bus.$emit('openpopup', {
                        'open': false
                    });                    
                    console.log('this.badImages: ', this.badImages);
                    // alert(this.badImages.join("\n"));
                    // console.log('After add person.');

                    
                    let addResultMessage = '';
                    if(!this.badImages.length) {
                        addResultMessage = 'Person created successfully.';
                    }
                        
                    
                    console.log('this.add_person_report 1 (this.badImages) : ', this.badImages);

                    let add_person_report = {
                        'badImages': this.badImages,
                        'spoofWarnings': this.spoofWarnings,
                        'result': addResultMessage
                    };

                    console.log('this.add_person_report full 1 : ', add_person_report);

                    bus.$emit('openpopup', {
                        'open': true,
                        'type': 'addpersonreport',                        
                        'title_form': 'Add person result',
                        'add_person_report': add_person_report
                    });



                    this.checkAddedFaces(totalfiles);                    
                }
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        // updatePerson(person_id, category_id){
        updatePerson(){
            
            let person_id = this.person.id,
                category_id = this.category_id; 
            
            let params = {
                    first_name: this.model_person.first_name,
                    last_name: this.model_person.last_name,
                    email: this.model_person.email,
                    info: this.model_person.info,
                    link: this.model_person.link,                    
                    uuid: this.model_person.uuid
                }
            
            if(category_id)
                params.category_id = category_id;
            
            axios.put( 
                `/persons/${person_id}`,
                params                
            ).then((response)=>{
                console.log('update person', response);
                bus.$emit('openpopup', {'open': false});                
            }).catch(function(error){                
                console.log('error updatePerson');
                console.log(error);
            });
        },
        checkAddedFaces(sendNum){
            // alert(`Num of sended faces:  ${sendNum}`);
            // alert(`New person id:  ${this.model_person.id}`);

            axios.get(`/persons/${this.model_person.id}`, {
                data: {},
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                // handle success
                // console.log('person get', response);
                // this.model_person = response.data;

                let getPerson = response.data;
                console.log('getPerson.uuid: ', getPerson.uuid);
                console.log('getPerson.faces.length: ', getPerson.faces.length);


            
            }).catch( (error) => {
                // handle error
                console.log(error);
            })

            
        },
        uploadImage(e){            
            const images = e.target.files;
            this.images = images;
            console.log(images);
            for (let i = 0; i < images.length; i++) {
                this.model_person.faces.push({
                    name: images[i].name,
                    progress: 100,
                    done: false
                });
                // this.sendImage(images[i], i);
                this.files.push(images[i]);
                console.log(i);                
            }
            console.log('faces list', this.model_person.faces);
        },
        sendImage(file, id){
            
            let formData = new FormData();

            formData.append(`person_id`, this.model_person.id);
            formData.append(`file`, file);
          
            axios.post( '/faces',
                formData,
                {
                    headers: {                        
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'updateDuringAddPerson': 'y'
                    },
                    onUploadProgress: (progressEvent) => {
                        let progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        this.model_person.faces[id].progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        if(progress === 100){
                            this.model_person.faces[id].done = true;
                        }
                    }
                }                
            ).then((responce)=>{
                console.log(responce);
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        sendPersonToSdk(person_id){
            
            let formData = new FormData();
            
            if(this.image_turn_id){
                formData.append(`image_turn_id`, this.image_turn_id);
            } else {
                formData.append(`first_name`, this.model_person.first_name);
                formData.append(`last_name`, this.model_person.last_name);
                formData.append(`email`, this.model_person.email);
                formData.append(`info`, this.model_person.info);
                formData.append(`link`, this.model_person.link);
                formData.append(`category_id`, this.model_person.category_id);
                        
                let totalfiles = this.images.length;
                for (let index = 0; index < totalfiles; index++) {
                    formData.append("faces[]", this.images[index]);
                }
            }
            
            axios.post( '/persons/sendPersonTosdk',
               formData,
                {
                    headers: {                        
                        "Content-Type": "multipart/form-data",                        
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'updateDuringAddPerson': 'y'
                    }
                }       
            ).then((response)=>{
                this.sendPersonSDKnum++;

                console.log('send person to sdk', response.data);
                console.log('added person_uuid', response.data.person_uuid);
                
                if( response.data.image_turn_id ){
                    this.image_turn_id = response.data.image_turn_id;
                }

                // API v2 may return person_uuid on enqueue; wait for poll report
                // (good_image/bad_image) before finishing enroll.
                const enrollDone = !!(response.data.good_image || response.data.bad_image);
                
                if( !enrollDone && this.sendPersonSDKnum < this.sendPersonSDKlimit)
                    setTimeout(()=>{this.sendPersonToSdk();}, 2000);
                
                if( enrollDone && response.data.person_uuid ){
                    this.model_person.uuid = response.data.person_uuid;

                    console.log('this.files: ', this.files);

                    const bad = (response.data.bad_image && response.data.bad_image.description) || [];
                    bad.forEach((description, curIndex) => {
                        let fileIndex = response.data.bad_image.index[curIndex];
                        let fileName = (this.files[fileIndex] && this.files[fileIndex].name) || fileIndex;
                        let curMessage = `Image ${fileName} not added, ${description}`;

                        this.badImages.push(curMessage);
                    });

                    if (this.isSpoofSuspicion(response.data.spoofing_atack)) {
                        this.spoofWarnings.push('Подозрение на спуф (изображение может быть подделкой).');
                    }

                    this.addPerson();
                }
                    
                
                if( this.sendPersonSDKnum >= this.sendPersonSDKlimit )
                    console.log('Num of send limit is over.');


            }).catch(function(error){
                console.log('FAILURE!!');
                console.log('error from send person to sdk: ', error);
            });
        },
        donePerson(event){            
            let doneButton = event.target;
            console.log('Click done!: ', doneButton);
            doneButton.disabled = true;
            const person_id = this.model_person.id;
            this.sendPersonToSdk(this.sendPersonSDKnum);
        },
        removeImagePerson(faceOrId, key){
            const face = (faceOrId && typeof faceOrId === 'object') ? faceOrId : null;
            const hash = face ? (face.hash || face.id) : faceOrId;
            const uuid = this.model_person.uuid || this.model_person.person_uuid;
            if (typeof key === 'number') {
                this.model_person.faces.splice(key, 1);
            }

            axios.delete(`/faces/${encodeURIComponent(hash)}`, {
                params: { person_uuid: uuid, images_hash: hash },
            }).then((responce)=>{
                console.log('delete person', responce);
            }).catch(function(){
                console.log('FAILURE!!');
            });

        }
    },
    mounted(){
        
        console.log('this.person from mounted form person: ', this.person);

        this.title_form = this.prop_titleform;
        if(this.person){
            this.model_person = this.person;
        }
    }
}
</script>

<style scoped lang="scss">
    .btn-close{
        margin-left: 1rem;
    }
    .colors_block{
        background: var(--color-dark70);
        padding: 1rem;
        display: flex;
        .color_radio{
            cursor: pointer;
            margin: 0 0.5rem;
        }
    }
</style>
